import { useTranslation } from "react-i18next";
import ImageHeader from "../../../../components/image-header/image-header";
import customizedImg from "../../../../assets/imgs/services/international/customized.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import Helmet from "react-helmet";

function Customized() {
  const [tCustomized] = useTranslation("customizedPage");
  const [tSMetaData] = useTranslation("metaData");
  const idCustomized = "7818a77c-3634-4a44-b753-354c0d8f16bb";
  const [textDescription, setTextDescription] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["products-internacional-submenu"])[3]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["products-international-submenu"])[3]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idCustomized}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("customized.title")}</title>
        <meta
          name="description"
          content={tSMetaData("customized.description")}
        />
      </Helmet>
      <ImageHeader
        section={tCustomized("header.section")}
        title={tCustomized("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tCustomized("description.content"))
        }
        contactSales={tCustomized("header.contact-sales")}
        contactProductID="btnContactCustomized"
        imgBackground={customizedImg}
      />
    </>
  );
}

export default Customized;
